<template>
  <div class="container">
    <div class="content">
      <div class="info">
        <img src="../../assets/img/new_logo_bg.png" alt="" class="leftImg" />
        <img src="../../assets/img/blue.png" alt="" class="blue" />
        <img src="../../assets/img/yellow.png" alt="" class="yellow" />
        <img src="../../assets/img/pad.png" alt="" class="pad" />
      </div>
      <div class="data-view">
        <div class="b-routerWrap">
          <span class="agreement" v-if="$route.path !== '/login/bind'"
            >登录即代表同意
            <router-link to="/agreement" target="_blank"
              ><span>《知图协议》</span></router-link
            >
          </span>
          <div class="copyright">
            京ICP备17041952号-2 京公网安备11010802029194
          </div>
          <div class="s-routerWrap">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";
/deep/.ant-input:hover {
    border-color: #387df8 !important;
}
/deep/.ant-input:hover, /deep/.ant-input:focus {
    border-color: #387df8;
    -webkit-box-shadow: 0 0 0 2px rgba($color: #387df8, $alpha: 0.1);
    box-shadow: 0 0 0 2px rgba($color: #387df8, $alpha: 0.1);
}
.container {
  height: 100vh;
  width: 100%;
  background: #fff;
  .content {
    width: 100%;
    height: 100vh;
    position: relative;
    min-height: 768px;
    min-width: 1366px;
    .info {
      position: absolute;
      left: 0;
      width: 710px;
      height: 100%;
      .leftImg {
        width: 100%;
        height: 100%;
      }
      .blue {
        position: absolute;
        left: 18%;
        top: 6%;
      }
      .yellow {
        position: absolute;
        right: 10%;
        top: 76%;
      }
      .pad {
        position: absolute;
        left: 8%;
        top: 24%;
        width: 810px;
      }
    }
    .data-view {
      background: #fff;
      margin-left: 710px;
      height: 100%;
      overflow: hidden;
      .b-routerWrap {
        margin-left: 120px;
        border: 1px solid #fff;
        position: relative;
        height: 100vh;
        .agreement {
          position: absolute;
          bottom: 80px;
          font-size: 16px;
          margin-left: calc(50% - 99px);
          color: #7f7f7f;
          span {
            color: #387df8;
          }
        }
        .copyright {
          position: absolute;
          bottom: 40px;
          font-size: 14px;
          margin-left: calc(50% - 166px);
          color: #d4d4d4;
        }
        .s-routerWrap {
          width: 440px;
          height: 520px;
          background: #fff;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }
      }
    }
  }
}
//选中文本的背景色
/deep/::selection {
    background: #1890ff !important;
}
</style>
<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  font-family: 'Microsoft-yahei';
}
</style>